import { render, staticRenderFns } from "./IntegrationFeedbackCard.vue?vue&type=template&id=1dc35929&scoped=true"
import script from "./IntegrationFeedbackCard.vue?vue&type=script&lang=ts"
export * from "./IntegrationFeedbackCard.vue?vue&type=script&lang=ts"
import style0 from "./IntegrationFeedbackCard.vue?vue&type=style&index=0&id=1dc35929&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc35929",
  null
  
)

export default component.exports